import 'vue-toast-notification/dist/theme-sugar.css'
import ToastPlugin from 'vue-toast-notification'
import { defineNuxtPlugin } from '#app'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(ToastPlugin)
})
